module.exports = __webpack_public_path__ + "img/bg.6fa9ed71.jpg";